'use client';

import type React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

interface ClientErrorBoundaryProps {
  children: React.ReactNode;
}

function ErrorFallback({
  error,
  resetErrorBoundary,
}: { error: Error; resetErrorBoundary: () => void }) {
  return (
    <div>
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
    </div>
  );
}

export default function ClientErrorBoundary({
  children,
}: ClientErrorBoundaryProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // optionally reset state or retry logic
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
